import { render } from "./GlobalEmojiPicker.vue?vue&type=template&id=7d2dd14f&scoped=true"
import script from "./GlobalEmojiPicker.vue?vue&type=script&lang=js"
export * from "./GlobalEmojiPicker.vue?vue&type=script&lang=js"

import "./GlobalEmojiPicker.vue?vue&type=style&index=0&id=7d2dd14f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2dd14f"]])

export default __exports__